import { BusinessDetails } from '../../slices/businessDetails';
import { CoverDetails } from '../../slices/coverDetails';
import { ExtraInfo } from '../../slices/extraInfo';
import { Quote } from '../../slices/quote';
import { Cover } from '../../types/cover';
import { Risk, RiskLocation } from '../../types/policy';
import { OccupationsListItem } from '../../types/refData';
import { Nullable } from '../../types/utils';
import { getBuildingAndContentsRisk } from './getBuildingAndContentsRisk';
import { getLiabilityRisk } from './getLiabilityRisk';
import { getPortableItemsRisk } from './getPortableItemsRisk';
import { RiskMetaType } from './getRiskMeta';
import { getTaxAuditRisk } from './getTaxAuditRisk';
import { getTheftMoneyGlassRisk } from './getTheftMoneyGlassRisk';

export const coverToRisk = (
  cover: Cover,
  details: {
    riskMeta: RiskMetaType;
    coverDetails: Nullable<CoverDetails>;
    extraInfo: Nullable<ExtraInfo>;
    isPropertyOwner: boolean;
    businessLocation: RiskLocation;
    businessDetails: Partial<BusinessDetails>;
    quote: Nullable<Quote>;
    requestCovers: Cover[];
    propertyOwnerOccupation: OccupationsListItem | undefined;
  }
) => {
  const liabilityRisk: Risk = getLiabilityRisk(details);

  const portableItemsRisk: Risk = getPortableItemsRisk(details);

  const buildingAndContentsRisk: Risk = getBuildingAndContentsRisk(details);

  const theftMoneyGlassRisk: Risk = getTheftMoneyGlassRisk(details);

  const taxAuditRisk: Risk = getTaxAuditRisk(details);

  switch (cover) {
    case Cover.Liability:
      return liabilityRisk;
    case Cover.BuildingAndContents:
    case Cover.BusinessInterruption:
      return buildingAndContentsRisk;
    case Cover.PortableItems:
    case Cover.Breakdown:
      return portableItemsRisk;
    case Cover.Theft:
    case Cover.Money:
    case Cover.Glass:
      return theftMoneyGlassRisk;
    case Cover.TaxAudit:
      return taxAuditRisk;
    default:
      throw new Error(`Unknown cover ${cover}`);
  }
};
